import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import ABCyaLib from '@abcya/abcya_lib';

export default class RaceBanner extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'Banner', this);

    this.jrTxt = this.scene.add.bitmapText(0, -15, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.banner'), ABCyaLib.Environment.instance.gameConfig.bannerSize).setTintFill('0xFFFFFF')
      .setOrigin(.5)
      .setAngle(-13);
    this.add(this.jrTxt);
  }
}